import {AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalNavigationService} from '../../../../services/gui/modal/modal-navigation.service';
import {AttachmentDTO, DisplayType} from '../../../../services/api/api';
import {DomSanitizer} from '@angular/platform-browser';
import {AttachmentService} from "../../../../services/attachment.service";

@Component({
  selector: 'app-attachment-preview',
  templateUrl: './attachment-preview.component.html',
  styleUrls: ['./attachment-preview.component.scss'],
  standalone: false,
})
export class AttachmentPreviewComponent implements OnInit, AfterViewInit, OnDestroy {
  url: string;
  isInModalContext: boolean;

  constructor(
    private attachmentService: AttachmentService,
    private modalNavigation: ModalNavigationService,
    public sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef
  ) {}

  _attachment: AttachmentDTO;

  get attachment(): AttachmentDTO {
    return this._attachment;
  }

  @Input() set attachment(val: AttachmentDTO) {
    this._attachment = val;
    if (this._attachment) {
      // TODO Waiting for thumbnails
      switch (this._attachment.displayType) {
        case DisplayType.IFRAME: {
          this.url = this.attachmentService.updateIframeUrl(this._attachment);
          break;
        }
      }
    }
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.attachment = this.modalNavigation?.getCurrentNavigation()?.data;
    }
  }

  ngAfterViewInit() {
    this.ref.detach();
  }

  ngOnDestroy(): void {
    this.ref.reattach();
  }
}
